/* eslint-disable react/prop-types */
import React from 'react';
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	Chip,
	Typography,
} from '@mui/material';
import { ITransactionOption } from 'features/transaction-lookup/types';
import { formatDateTimeToShowUser } from 'features/common/helpers';

interface TransactionSelectorProps {
	open: boolean;
	transactions: ITransactionOption[];
	onSelect: (transactionId: number) => void;
	onClose: () => void;
}

export const TransactionSelector = ({
	open,
	transactions,
	onSelect,
	onClose,
}: TransactionSelectorProps): JSX.Element => {
	return (
		<Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
			<DialogTitle>
				<Typography variant="h6">Múltiples Transacciones Encontradas</Typography>
				<Typography variant="body2" color="text.secondary">
					Se encontraron {transactions.length} transacciones con este E-Ticket. Seleccione una:
				</Typography>
			</DialogTitle>
			<DialogContent dividers>
				<TableContainer component={Paper} variant="outlined">
					<Table>
						<TableHead>
							<TableRow sx={{ bgcolor: 'primary.main' }}>
								<TableCell sx={{ color: 'white', fontWeight: 'bold' }}>ID</TableCell>
								<TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Order ID</TableCell>
								<TableCell sx={{ color: 'white', fontWeight: 'bold' }}>CRM Ticket</TableCell>
								<TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Titular</TableCell>
								<TableCell sx={{ color: 'white', fontWeight: 'bold' }} align="right">
									Monto
								</TableCell>
								<TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Creación</TableCell>
								<TableCell sx={{ color: 'white', fontWeight: 'bold' }} align="center">
									Acción
								</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{transactions.map((tx) => (
								<TableRow key={tx.id} hover sx={{ cursor: 'pointer' }} onClick={() => onSelect(tx.id)}>
									<TableCell>{tx.id}</TableCell>
									<TableCell>{tx.orderId}</TableCell>
									<TableCell>
										<Chip label={tx.crmTicket} size="small" color={tx.isBitrixDeal ? 'primary' : 'default'} />
									</TableCell>
									<TableCell>{tx.cardholder}</TableCell>
									<TableCell align="right">
										<Typography variant="body2" fontWeight="bold">
											{tx.amount} {tx.coinCode}
										</Typography>
									</TableCell>
									<TableCell>{formatDateTimeToShowUser(tx.createdAt)}</TableCell>
									<TableCell align="center">
										<Button variant="outlined" size="small" onClick={() => onSelect(tx.id)}>
											Seleccionar
										</Button>
									</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</TableContainer>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>Cancelar</Button>
			</DialogActions>
		</Dialog>
	);
};
